var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionIconVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.83 2.17 20 5.81 20H14.18C17.82 20 19.99 17.83 19.99 14.19V5.81C20 2.17 17.83 0 14.19 0ZM15.85 12.1C15.81 12.19 15.76 12.27 15.69 12.34L12.65 15.38C12.5 15.53 12.31 15.6 12.12 15.6C11.93 15.6 11.74 15.53 11.59 15.38C11.3 15.09 11.3 14.61 11.59 14.32L13.35 12.56H4.85C4.44 12.56 4.1 12.22 4.1 11.81C4.1 11.4 4.44 11.06 4.85 11.06H15.16C15.26 11.06 15.35 11.08 15.45 11.12C15.63 11.2 15.78 11.34 15.86 11.53C15.92 11.71 15.92 11.92 15.85 12.1ZM15.15 8.93H4.85C4.75 8.93 4.66 8.91 4.56 8.87C4.38 8.79 4.23 8.65 4.15 8.46C4.07 8.28 4.07 8.07 4.15 7.89C4.19 7.8 4.24 7.72 4.31 7.65L7.35 4.61C7.64 4.32 8.12 4.32 8.41 4.61C8.7 4.9 8.7 5.38 8.41 5.67L6.66 7.43H15.16C15.57 7.43 15.91 7.77 15.91 8.18C15.91 8.59 15.57 8.93 15.15 8.93Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionIconVector);
export default __webpack_public_path__ + "static/media/TransactionIconVector.0e5c579521dc32d99f5d32d33f4cafb0.svg";
export { ForwardRef as ReactComponent };